export default {
  path: '/workers',
  component: () => import(
    /* webpackChunkName: "workers-list" */
    /* webpackPrefetch: true */
    './List'
  ),
  children: [
    {
      path: 'vacation',
      component: () => import(
        /* webpackChunkName: "workers-vacation" */
        /* webpackPrefetch: true */
        './Vacation'
      ),
    },
    {
      path: 'create',
      component: () => import(
        /* webpackChunkName: "workers-create" */
        /* webpackPrefetch: true */
        './Create'
      ),
    },
    {
      path: ':id',
      component: () => import(
        /* webpackChunkName: "workers-detail" */
        /* webpackPrefetch: true */
        './Detail'
      ),
    },
  ],
};
